export type DeliveryAddress = {
  endereco: string;
  latitude: string;
  longitude: string;
  complemento: string;
};

export const readDeliveryAddress = (): DeliveryAddress => ({
  endereco: window.localStorage.getItem('enderecoEntrega') || '',
  latitude: window.localStorage.getItem('latitudeEntrega') || '',
  longitude: window.localStorage.getItem('longitudeEntrega') || '',
  complemento: window.localStorage.getItem('complementoEntrega') || ''
});

export const saveDeliveryAddress = (address: DeliveryAddress) => {
  window.localStorage.setItem('enderecoEntrega', address.endereco);
  window.localStorage.setItem('latitudeEntrega', address.latitude);
  window.localStorage.setItem('longitudeEntrega', address.longitude);
  window.localStorage.setItem('complementoEntrega', address.complemento || '');
};

export const saveDeliveryTerms = (taxa: string, tempo: string) => {
  window.localStorage.setItem('taxaEntrega', taxa || '');
  window.localStorage.setItem('tempoEntrega', tempo || '');
};
